import LC from "@/repositories/lisacomunica/lc";

/*
 * Schedulazioni di invio su LisaComunica, indirizzate con l'id della procedura
 * LisaWeb: è quello che il frontend ha in mano, e la coppia agenzia + procedura
 * identifica una sola schedulazione.
 *
 * update e destroy rispondono 409 quando l'invio è già partito o concluso: quel
 * rifiuto è la ragione per cui vanno chiamati PRIMA di aggiornare LisaWeb.
 */
export default {
  show(procedureId) {
    let resource = `/schedules`;
    return LC.get(`${resource}/${procedureId}`);
  },
  update(procedureId, payload) {
    let resource = `/schedules`;
    return LC.put(`${resource}/${procedureId}`, payload);
  },
  destroy(procedureId) {
    let resource = `/schedules`;
    return LC.delete(`${resource}/${procedureId}`);
  },
};
